import { useEffect, useState } from 'react';
import { SfeduSignIn } from './SfeduSignIn';

export function AuthMethods({ children, registration = false, forceAlternative = false }) {
  const [available, setAvailable] = useState(null);
  const [expanded, setExpanded] = useState(forceAlternative);
  const showAlternative = available === false || expanded;
  useEffect(() => { if (forceAlternative) setExpanded(true); }, [forceAlternative]);

  return <>
    {available !== false && <p className="auth-intro">
      {registration ? 'Начните с учётной записи университета' : 'Войдите с учётной записью университета'}
    </p>}
    <SfeduSignIn onAvailability={setAvailable} primary />
    {available === null && <p className="auth-methods-loading" role="status">Проверяем доступность входа…</p>}
    {available !== false && <button type="button" className="auth-alternative-toggle"
      aria-expanded={showAlternative} aria-controls="auth-alternative-methods"
      onClick={() => setExpanded(value => !value)}>
      {registration ? 'Регистрация с почтой и другие способы' : 'Войти с паролем или через Leader-ID'}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"
        style={{ transform: showAlternative ? 'rotate(180deg)' : undefined }}>
        <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>}
    {showAlternative && <div className="auth-alternative-methods" id="auth-alternative-methods">{children}</div>}
  </>;
}
